
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'Historia',
	'noDashboardFound': 'No se puede recuperar la historia. Es posible que ya no exista o que no tiene suficientes privilegios para verlo.',
	'noDashboardCapability': 'No dispone de la función para utilizar historias',
	'noDashboardPermision': 'No tiene privilegios suficientes para ver esta historia',
	'defaultName': 'Nueva historia',
	'storyProperties': 'Propiedades de la historia',
	'createAvDataStoryLabel': 'Historia',
	'createAvSlideShowLabel': 'Pase de diapositivas',
	'createAvPanAndZoomLabel': 'Recorrido guiado',
	'dashboard_save_success': 'Se ha guardado su historia.',
	'cmEmptySelection': 'Se ha suprimido la historia. Intente guardar como nueva historia.',
	'createStoryTitle': 'Crear una historia',
	'transitionStyleTitle': 'Estilo de transición',
	'createButton': 'Crear',
	'cancelButton': 'Cancelar',
	'dashboardResetTitle': 'Restablecer historia',
	'dashboardResetMessage': '¿Está seguro de que desea volver a establecer todos los cambios aplicados a esta historia?',
	'dashboardResetToast': 'Se ha restablecido su historia.',
	'filter_drag_and_drop_all_tabs': 'Arrastre y suelte los datos aquí para filtrar todas las escenas.',
	'filter_drag_and_drop_current_tab': 'Arrastre y suelte los datos aquí para filtrar esta escena.',
	'filterIconLabel_Global': 'Todas las escenas',
	'filterIconLabel_Tab': 'Esta escena',
	'filterIconTooltip_Global': 'Todas las escenas',
	'filterIconTooltip_Tab': 'Esta escena',
	'filterOverflowMenu_Global': 'Menú de desbordamiento Todas las escenas',
	'filterOverflowMenu_Tab': 'Menú de desbordamiento Esta escena',
	'renameScene': 'Renombrar escena',
	'duplicateScene': 'Duplicar escena',
	'deleteScene': 'Suprimir escena',
	'editTimelineHighlight': 'Editar resaltado',
	'deleteTimelineHighlight': 'Suprimir resaltado',
	'filter_includesAll': 'Incluye todo',
	'timeline_highlight_moved_to': 'El resaltado de línea temporal %{id} se ha movido a %{time}',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Seleccionar',
	'newDefaultStoryName': 'Historia: %{modelName}',
	'exportLabel': 'Guardar',
	'exportAsLabel': 'Guardar como:',
	'exportDialogTitle': 'Guardar como una historia',
	'exportDialogFooter': 'Botones Guardar y cancelar',
	'loadAfterExportLabel': 'Abrir historia después de guardar',
	'selectTemplateLabel': 'Seleccionar una plantilla',
	'outOfBoundsWarningMessage': 'Algunos widgets del panel de control están fuera de la cuadrícula y es posible que no se visualicen correctamente después de la exportación.',
	'emptyExploreCardsWarningMessage': 'Se han suprimido tarjetas vacías durante el proceso de guardar una historia.',
	'dashboard_export_success': 'Se ha guardado correctamente el panel de control como una historia.',
	'explore_export_success': 'Su exploración se ha guardado correctamente como una historia.',
	'toastUpgradeDone': 'Se ha actualizado su historia. Guarde ahora para mantener un rendimiento óptimo.',
	'navigationMarker': 'Marcador de navegación',
	'navigateMarkers': 'Marcadores de navegación',
	'navNextMarker': 'Marcador siguiente',
	'navPrevMarker': 'Marcador anterior',
	'navPrevMarkerAbbreviated': 'Marcador anterior',
	'timelineSettingsButton': 'Opciones de reproducción',
	'autoPlay': 'Reproducir todas las escenas',
	'loop': 'Bucle',
	'refreshData': 'Renovar al iniciar',
	'slideshowLabel': 'Presentación con diapositivas',
	'panAndZoomLabel': 'Recorrido guiado',
	'slideShowLayoutLabel': 'Diseño de presentación con diapositivas',
	'panAndZoomLayoutLabel': 'Diseño de recorrido guiado',
	'panAndZoomLayoutFooter': 'Un diseño de recorrido guiado es una recopilación de escenas en un mismo lienzo. Cuando se ejecuta este tipo de historia, la presentación hace panorámicas y zooms de cada escena en orden secuencial. No es lo mismo que un diseño de presentación de diapositivas, en el que cada escena se presenta en un lienzo nuevo. El diseño de recorrido guiado con tres escenas conectada mediante líneas permite crear una secuencia horizontal de escenas. Esto resulta de utilidad para mostrar una línea temporal.',
	'PanAndZoomLayout1': '5 escenas dispuestas en forma de rectángulo',
	'PanAndZoomLayout2': '4 escenas dispuestas formando una escalera que asciende desde la izquierda hasta la derecha',
	'PanAndZoomLayout3': '6 escenas dispuestas en forma de rectángulo',
	'PanAndZoomLayout4': '7 escenas dispuestas en forma de rectángulo, con 6 escenas pequeñas en la parte superior y 1 escena grande en la parte inferior',
	'PanAndZoomLayout5': '3 escenas dispuestas con 2 escenas pequeñas en la parte superior y 1 escena grande en la parte inferior',
	'PanAndZoomLayout6': 'Secuencia de 4 escenas dispuestas horizontalmente',
	'pageSelectWarning': 'Seleccione una escena.',
	'noSceneTransitionLabel': 'Ninguno',
	'sceneTransitionPropertyLabel': 'Transición de escena',
	'animatedPathSceneTransitionLabel': 'Ruta con animación',
	'sweepSceneTransitionLabel': 'Barrido',
	'storyTypeLabel': 'Tipo de historia',
	'layoutLabel': 'Diseño',
	'tabName_animation': 'Animación',
	'propAniAnimation': 'Animación',
	'propAniTypeEntrance': 'Animación de entrada',
	'propAniDirectionIn': 'Dirección de entrada',
	'propAniTypeExit': 'Animación de salida',
	'propAniDirectionOut': 'Dirección de salida',
	'propAniDirection': 'Dirección',
	'propAniEntrance': 'Entrada',
	'propAniTypeEntranceSlideIn': 'Salir deslizándose',
	'propAniTypeEntranceFadeIn': 'Fundido de entrada',
	'propAniTypeEntrancePivotIn': 'Girar hacia dentro',
	'propAniTypeEntranceScaleIn': 'Volver al tamaño original',
	'propAniTypeEntranceShrinkIn': 'Reducir',
	'propAniDirectionInLeft': 'Desde la izquierda',
	'propAniDirectionInRight': 'Desde la derecha',
	'propAniDirectionInTop': 'Desde arriba',
	'propAniDirectionInBottom': 'Desde abajo',
	'propAniExit': 'Salir',
	'propAniTypeExitSlideIn': 'Entrar deslizándose',
	'propAniTypeExitFadeIn': 'Fundido de salida',
	'propAniTypeExitPivotOut': 'Girar hacia fuera',
	'propAniTypeExitScaleIn': 'Ampliar tamaño',
	'propAniTypeExitExpandOut': 'Expandir hacia fuera',
	'propAniDirectionOutLeft': 'Hacia la izquierda',
	'propAniDirectionOutRight': 'Hacia la derecha',
	'propAniDirectionOutTop': 'Hacia arriba',
	'propAniDirectionOutBottom': 'Hacia abajo',
	'propAniEntranceTime': 'Iniciar en (seg):',
	'propAniExitTime': 'Finalizar en (seg):',
	'animationNoEntranceText': 'La animación de entrada no se realizará si el widget está al principio de la escena.',
	'animationNoExitText': 'La animación de entrada no se realizará si el widget está al final de la escena.',
	'propAniTypeDataEntrance': 'Entrada de datos',
	'propAniRevealDuration': 'Duración de animación de entrada',
	'timelineAnimationProperties': 'Abrir propiedades de animación',
	'scenesPropertiesSection': 'Escenas',
	'editStoryCoachMarkTitle': 'Editar historia',
	'editStoryCoachMarkContents': 'Pulse el icono del lápiz para editar esta historia.',
	'addDataStoryCoachMarkContents': 'Arrastre los datos del panel de datos y suéltelos en la historia.',
	'expandSceneCoachmarkTitle': 'Abrir línea temporal',
	'expandSceneCoachmarkContents': 'Animar una escena ajustando la visibilidad del objeto en función del tiempo y la duración.',
	'overviewCoachmarkTitle': 'Escenas de descripción general',
	'overviewCoachmarkContents': 'Utilice las escenas de descripción general del principio y del final de la historia para tener una visión conjunta de todas las escenas. Desde una escena de descripción general, pulse una escena y arrástrela para intercambiarla por otra. Puede mostrar u ocultar las escenas de descripción general en las propiedades de la historia.',
	'animatedPathCoachmarkTitle': 'Ruta con animación',
	'animatedPathCoachmarkContents': 'Para dotar de animación a un objeto entre una escena y la siguiente, duplique una escena con un objeto. A continuación, mueva, cambie el tamaño o gire el objeto duplicado en la escena nueva.',
	'propShowStoryOverviewFirstSlide': 'Mostrar todas las escenas al principio',
	'propShowStoryOverviewLastSlide': 'Mostrar todas las escenas al final',
	'storySceneSingleCountLabel': '1 escena',
	'storySceneCountLabel': '%{count} escenas',
	'storySceneRangeCountLabel': 'Escena %{index} de %{count}',
	'storySceneExpand': 'Abrir línea temporal',
	'storySceneActionMenu': 'Iniciar menú de opciones de escena',
	'timelineRightContainerLabel': 'Grupo de control de botón de línea temporal',
	'timelineViewLabel': 'Línea temporal',
	'timelineZoomFit': 'Ajustar a la pantalla',
	'timelineZoomIn': 'Acercar',
	'timelineZoomOut': 'Alejar',
	'timelinePositionIndicator': 'indicador de posición de línea temporal en %{position}',
	'timelinePositionIndicatorMoveLeftTo': 'mover indicador de posición de línea temporal a la izquierda en %{position}',
	'timelinePositionIndicatorMoveRightTo': 'mover indicador de posición de línea temporal a la derecha en %{position}',
	'sceneStart': 'Ir al principio de la escena en %{position}',
	'sceneEnd': 'Ir al final de la escena en %{position}',
	'timelineHighlightTitle': 'Resaltar',
	'addTimelineHighlight': 'Añadir resaltado',
	'addSceneBtnTitle': 'Añadir una nueva escena con plantilla predeterminada',
	'addSceneChevronBtnTitle': 'Seleccionar una plantilla de escena',
	'timelinePlay': 'Reproducir',
	'timelinePause': 'Pausa',
	'sceneNavigation': 'Desplazamiento por las escenas',
	'navNextScene': 'Escena siguiente',
	'navPrevScene': 'Escena anterior',
	'navPrevSceneAbbreviated': 'Escena anterior',
	'navExitFullScreen': 'Salir de pantalla completa',
	'navToggleOverview': 'Conmutar descripción general',
	'rowNumber': 'Fila %{number}',
	'overviewBtnLabel': 'Descripción general',
	'sceneListStart': 'Descripción general de inicio',
	'sceneListEnd': 'Descripción general de fin',
	'timelineLeftHandle': 'punto de arrastre izquierdo para %{name}',
	'timelineRightHandle': 'punto de arrastre derecho para %{name}',
	'timelineLeftHandleNoTitle': 'punto de arrastre izquierdo',
	'timelineRightHandleNoTitle': 'punto de arrastre derecho',
	'timelineMoveLeft': 'Mover %{object} a la izquierda',
	'timelineMoveRight': 'Mover %{object} a la derecha',
	'timelineMoveWidget': 'El widget de línea temporal se ha movido a %{newStartTime} y %{newEndTime}',
	'timelineMoveWidgetStartTime': 'El widget de línea temporal de hora inicial se ha cambiado a %{newStartTime}',
	'timelineMoveWidgetEndTime': 'El widget de línea temporal de hora final se ha cambiado a %{newEndTime}',
	'timelineMoveWidgetDown': 'El widget de línea temporal se ha bajado',
	'timelineMoveWidgetUp': 'El widget de línea temporal se ha subido',
	'addSceneTitle': 'Añadir una escena',
	'blankSceneLayout': 'Blanco',
	'titleSceneLayout': 'Título con subtítulo',
	'sceneLayout1': 'Título con texto junto a una visualización',
	'sceneLayout2': 'Título con una visualización',
	'sceneLayout3': 'Título con dos visualizaciones',
	'sceneLayout4': 'Finalidad múltiple',
	'sceneLayout5': 'Sin título con texto junto a una visualización',
	'sceneLayout6': 'Finalidad múltiple 2 por 2',
	'sceneLayout7': 'Finalidad múltiple 2 junto a 1',
	'sceneLayout8': 'Finalidad múltiple 1 junto a 2',
	'sceneLayout9': 'Finalidad múltiple 1 sobre 2',
	'sceneLayout10': 'Finalidad múltiple 2 sobre 1',
	'sceneLayout11': 'Finalidad múltiple 4 sobre 1',
	'sceneLayout12': 'Finalidad 1 sobre 1 junto a 2 por 2 sobre 1',
	'titleWidgetPlaceholderText': 'Escriba su título aquí',
	'subtitleWidgetPlaceholderText': 'Escriba su subtítulo aquí',
	'createStoryViewTitle': 'Crear historia',
	'defaultStoryName': 'Nueva historia',
	'screenshot_label': 'Historia %{title}',
	'screenshot_label_scene': 'Escena %{sceneTitle} de la historia %{title}',
	'filmstripHandleOpenLabel': 'Abrir selector de escenas',
	'filmstripHandleCloseLabel': 'Cerrar selector de escenas'
});
